/* eslint-disable import/no-anonymous-default-export */
import {
    CONTACTS
} from '../actions/types'

export default (state = [], action) => {
    switch (action.type) {
        case CONTACTS:
            return action.payload;
        default:
            return state;
    }
}